module.exports = __webpack_public_path__ + "r-v3/img/icon-circle-graph_off.7d28464e.svg";